<!-- VIEW PAGE CONTENT FOR CLIENTS (ALSO FOR frontend) -->
<!-- <div class="flex justify-content-center align-items-center text-xl font-bold mb-3" *ngIf="onExtendedMobile()">
	{{ titleId | translate }}
</div> -->
<div *ngIf="helpGuestLoading || loading">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>
<div *ngIf="!helpGuestLoading && !loading" class="layout-content px-0 pt-3" [ngClass]="layoutMarginResponsive()">
	<!-- FILTERS -->
	<div class="grid">
		<div *ngIf="appid !== 'intercomsetup'" [class]="col6HeaderPage('left')">
			<p-button label="{{ 'NEED_HELP' | translate }}" icon="pi cm-help" size="large"
				(onClick)="openNewTabContactUs()" [rounded]="false" [text]="true" severity="secondary" styleClass="font-semibold">
			</p-button>
		</div>
		<div *ngIf="appid === 'intercomsetup'" [class]="col6HeaderPage('left')">
			<p-button label="{{ 'FOOTER_CONTACT_US' | translate }}" icon="pi cm-help" size="large"
				(onClick)="openIntercomSupport()" [rounded]="false" [text]="true" severity="secondary" styleClass="font-semibold">
			</p-button>
		</div>
		<div [class]="col6HeaderPage('right')">
			<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
				<i class="pi cm-search"></i>
				<input [formControl]="searchFilter" pInputText type="text" class="surface-900" id="helper-input-search"
					placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputTextWidth()" class="pr-6 surface-900"
					maxlength="254" />
			</span>
		</div>
	</div>
	<!-- CONTENT -->
	<div *ngIf="filter==='' && !onExtendedMobile()">
		<app-helper-list [controller]="false"></app-helper-list>
	</div>
	<div *ngIf="filter==='' && onExtendedMobile()">
		<app-helper-list-mobile></app-helper-list-mobile>
	</div>
	<div *ngIf="filter!==''">
		<p-accordion (click)="accordionAction()">
			<p-accordionTab *ngFor="let subsection of helpSearchList;">
				<ng-template pTemplate="header" class="grid">
					<div class="col-6 py-0"><span class="font-bold white-space-nowrap">{{subsection.Title}}</span></div>
				</ng-template>
				<app-helper-subsection [subsection]="subsection" [controller]="false"></app-helper-subsection>
			</p-accordionTab>
		</p-accordion>
	</div>
</div>